import { NgModule } from '@angular/core';
import { MsInputPasswordComponent } from './ms-input-password.component';
import { SharedLibsModule } from 'app/shared/shared-libs.module';

@NgModule({
	declarations: [MsInputPasswordComponent],
	imports: [SharedLibsModule],
	exports: [MsInputPasswordComponent],
	providers: [],
})
export class MsInputPasswordModule {}
